import { hasValue } from "@repo/helpers";
import { useMemo } from "react";

import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "../../basic/dialog";
import { useAlertContext } from "../../providers";

export function AlertPopup() {
	const { alert, clearAlert } = useAlertContext();
	const { onCancel, onConfirm, onReject, message, confirmDisabled } = alert;
	const cancelText = alert.cancelText || "Cancel";
	const confirmText = alert.confirmText || "Confirm";
	const rejectText = alert.rejectText || "Alert";

	const shown = hasValue(message) || hasValue(alert?.body);

	const body = useMemo(() => alert?.body ?? <span>{message}</span>, [alert, message]);

	return (
		<AlertDialog open={shown} onOpenChange={(open) => !open && (onCancel ? onCancel() : clearAlert())}>
			<AlertDialogContent size={alert.size}>
				<AlertDialogHeader>
					<AlertDialogTitle>{alert.titleText || "Alert"}</AlertDialogTitle>
					<AlertDialogDescription>{body}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					{onCancel && <AlertDialogCancel onClick={onCancel}>{cancelText}</AlertDialogCancel>}
					{onReject && <AlertDialogAction onClick={onReject}>{rejectText}</AlertDialogAction>}
					{onConfirm && (
						<AlertDialogAction disabled={confirmDisabled} onClick={onConfirm}>
							{confirmText}
						</AlertDialogAction>
					)}
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}

export default AlertPopup;
